import React from 'react'
import PropTypes from 'prop-types'

import idx from 'idx'
import { Link } from 'react-router'
import { Grid, Icon, Label, Segment } from 'semantic-ui-react'
import { compose } from 'recompose'

import Enhancer from './FamilyAlbumDetailModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import ErrorMassive from 'Components/ErrorMassive'
import FACardGroup from 'Components/FACardGroup'
import FAPictureCard from 'Components/FAPictureCard'
import FASearchForm from 'Components/FASearchForm'
import PageHeaderRow from 'Components/PageHeaderRow'
import Pagination from 'Components/Pagination'
import PreviewModalGeneric from 'Components/PreviewModalGeneric'

import * as styles from './styles'
import { THEME_COLOR } from 'Global/constants'

const FamilyAlbumDetailModule = props => {
  const {
    eventName,
    isSearchVisible,
    pagination,
    pictures,
    previewOpen,
    previewPictures,
    router,
    setPage,
    togglePreview,
    toggleSearchForm,
  } = props

  const eventId = idx(props, _ => _.routeParams.eventId)

  const hasSearch = !eventId

  const mappedPictures = pictures.map((picture, index) => {
    return <FAPictureCard index={index} key={picture.id} onClick={togglePreview} picture={picture} fluid />
  })

  return (
    <Grid>
      {!hasSearch && (
        <PageHeaderRow title={eventName}>
          <Link to={'/familyAlbum'} style={styles.link}>
            <Icon name="arrow left" />
            Back to Events Overview
          </Link>
        </PageHeaderRow>
      )}

      {hasSearch && isSearchVisible && (
        <PageHeaderRow title={'Family Album Search'}>
          <Link to={'/familyAlbum'} style={styles.link}>
            <Icon name="arrow left" />
            Back to Events Overview
          </Link>
        </PageHeaderRow>
      )}

      <Grid.Row columns={hasSearch && isSearchVisible ? 2 : 1}>
        {hasSearch && isSearchVisible && (
          <Grid.Column width={4}>
            <div style={styles.form}>
              <Grid.Row>
                <FASearchForm router={router} />
              </Grid.Row>

              <br />

              <Grid.Row>
                <Pagination
                  itemName="picture"
                  items={pagination.totalPictures}
                  page={pagination.page}
                  pages={pagination.pages}
                  setPage={setPage}
                />
              </Grid.Row>
            </div>
          </Grid.Column>
        )}

        <Grid.Column width={hasSearch && isSearchVisible ? 12 : 16}>
          <Segment style={styles.rugCardsSegment}>
            {hasSearch && (
              <Label
                as="a"
                color={THEME_COLOR}
                corner="left"
                icon={isSearchVisible ? 'expand arrows alternate' : 'compress'}
                onClick={toggleSearchForm}
              />
            )}

            <FACardGroup>{mappedPictures}</FACardGroup>

            <ErrorMassive enabled={pictures && pictures.length === 0} message="No pictures found." />

            {(!hasSearch || !isSearchVisible) && pictures.length > 0 && (
              <div>
                <br />

                <Pagination
                  itemName="picture"
                  items={pagination.totalPictures}
                  page={pagination.page}
                  pages={pagination.pages}
                  setPage={setPage}
                />
              </div>
            )}
          </Segment>
        </Grid.Column>
      </Grid.Row>

      {previewOpen && <PreviewModalGeneric open={previewOpen} pictures={previewPictures} toggle={togglePreview} lightBackground />}
    </Grid>
  )
}

FamilyAlbumDetailModule.propTypes = {
  eventName: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired,
  isSearchVisible: PropTypes.bool.isRequired,
  loaderPending: PropTypes.bool.isRequired,
  pagination: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  pictures: PropTypes.array.isRequired,
  previewOpen: PropTypes.bool.isRequired,
  previewPictures: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
  setPage: PropTypes.func.isRequired,
  togglePreview: PropTypes.func.isRequired,
  toggleSearchForm: PropTypes.func.isRequired,
}

const composed = compose(
  withPermissions('modules.familyAlbum'),
  Enhancer,
  StandardLoader('Counting the events…'),
  StandardError,
)

export default composed(FamilyAlbumDetailModule)
